import { useState } from 'react';
import { Divider, Stack, Tooltip, TooltipProps, Typography } from '@mui/material';

type DorimPromoChartLabelProps = React.PropsWithChildren & {
  isFirst: boolean;
  isLast?: boolean;
  isPlanExceeded?: boolean;
  tooltipTitle?: TooltipProps['title'];
};

export const DorimPromoChartLabel = (props: DorimPromoChartLabelProps) => {
  const { isFirst, isLast, isPlanExceeded, tooltipTitle, children } = props;

  const [anchorEl, setAnchorEl] = useState<HTMLHRElement | null>(null);

  return (
    <Tooltip
      arrow
      placement="bottom"
      title={tooltipTitle}
      slotProps={{
        popper: {
          disablePortal: true,
          anchorEl,
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -50],
              },
            },
          ],
        },
      }}
    >
      <Stack
        direction={isFirst ? 'row-reverse' : 'row'}
        spacing={0.5}
        alignItems="flex-end"
        sx={{ minHeight: 48, mr: isLast && isPlanExceeded ? 7 : 0 }}
      >
        <Typography component={Stack} variant="Body/medium" lineHeight={20 / 14} textAlign="right" pt={1}>
          {children}
        </Typography>
        <Divider
          ref={setAnchorEl}
          flexItem
          variant="dashed"
          orientation="vertical"
          sx={{ borderColor: 'neutral.500' }}
        />
      </Stack>
    </Tooltip>
  );
};
